enum EstimateStatus {
    PendingEstimate,
    PendingApproval,
    CustomerDeclined,
    CustomerApproved
}

export default EstimateStatus